import React from 'react';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import useMediaQuery from '../../hooks/useMediaQuery';

/**
 * FilterReset
 *
 * A DWT reusable component
 *
 * @param {Object} props
 * @param {Object} props.setStart
 * @param {string} props.contextFilter
 * @param {string} props.dataFilter
 */
const FilterResetButton = ({ 
  filterType = 'api',
  setStart, 
  checked, 
  setChecked, 
  dataFilter, 
  scrollToTop, 
  resetContextFilter, 
  initialObj
}) => {
  const isDesktop = useMediaQuery( '( min-width: 1024px )' );

  const handleApiReset = ( e ) => {
    setStart( 0 );
    e.target.closest( '.inner-blocks-wrapper' )?.removeAttribute( dataFilter );
    const newChecked = typeof checked === 'object' ? ( !isEmpty( initialObj ) ? initialObj : {}) : '';
    setChecked( newChecked );
    scrollToTop();
  };

  const handleResetButton = ( e ) => {
    if ( !checked ) return;
    filterType === 'api' ? handleApiReset( e ) : resetContextFilter();
  };

  return (
    <button
      className={ `filters__btn--reset btn--secondary border border-solid p-5 text-12 self-end w-max-content ml-auto my-15 ${!isDesktop ? 'invisible max-h-0' : ''} ${!!( !checked || isEmpty( checked ) || isEqual( checked, initialObj ) ) ? 'opacity-30' : ''}` }
      type='button'
      onClick={ handleResetButton }
      disabled={ !!( !checked || isEmpty( checked ) || isEqual( checked, initialObj ) ) }
    >
      reset
    </button>
  );
};

export default FilterResetButton;
